<template>
  <a-modal :visible="visible" title="非常感谢您的反馈" @ok="handleOk" @cancel="handleCancel">
    <a-spin :spinning="loading">
      <a-textarea :auto-size="{ minRows: 4, maxRows: 8 }" v-model="content" placeholder="可以描述下不满意的地方， 我们全力优化（选填）..."></a-textarea>
    </a-spin>
  </a-modal>
</template>
<script>
import { feedback } from '@/api/feedback.js';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  data() {
    return {
      content: '',
      loading: false
    };
  },
  watch: {
    visible(value) {
      if (value) {
        this.init();
      }
    }
  },
  methods: {
    init() {
      this.content = '';
      this.loading = false;
    },
    handleCancel() {
      this.$emit('change', false);
    },
    async handleOk() {
      const userInfo = localStorage.getItem('userInfo');
      let nickname = '';
      if (userInfo) {
        nickname = JSON.parse(userInfo)['nickname'];
      }
      this.loading = true;
      feedback({
        userName: nickname,
        content: `${this.content}\n反馈类型： ${this.type}`,
        url: location.href
      })
        .then(() => {
          this.$emit('change', false);
          this.$message.success('反馈成功， 感谢您珍贵的建议');
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped></style>
